module.exports = __webpack_public_path__ + "static/media/main-slider-1.73759ac9.png";